export default __webpack_public_path__ + "static/media/whisper-evo.848d787d.glb";